module.exports = __webpack_public_path__ + "static/media/cloud.208ba5a4.svg";